import React from 'react'
import Home from 'view/page/home'
import FootballDevelopment from 'view/page/football-development'
import FootballAdministration from 'view/page/football-administration'
import FootballOperations from 'view/page/football-operations'
import GovernanceAndQA from 'view/page/football-development/pages/governance-and-qa'
import PerformancePathway from 'view/page/football-development/pages/performance-pathway'
import PlayersEppp from 'view/page/football-development/pages/eppp'
import EPPPPlayerDevelopment from 'view/page/football-development/pages/eppp/pages/player-development'
import PlayersErdp from 'view/page/football-development/pages/erdp'
import ComingSoon from 'view/component/coming-soon'
import * as ROUTES from './routes'

export const navRoutes = [
  {
    component: <Home />,
    exact: false,
    href: ROUTES.HOME
  },
  {
    component: <FootballDevelopment />,
    exact: false,
    href: ROUTES.FOOTBALL_DEVELOPMENT
  },
  {
    component: <FootballAdministration />,
    exact: false,
    href: ROUTES.FOOTBALL_ADMINISTRATION
  },
  {
    component: <FootballOperations />,
    exact: false,
    href: ROUTES.FOOTBALL_OPERATIONS
  },
  {
    component: <PlayersEppp />,
    exact: false,
    href: ROUTES.PLAYERS_EPPP
  },
  {
    component: <EPPPPlayerDevelopment />,
    exact: false,
    href: ROUTES.EPPP_PLAYER_DEVELOPMENT
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.COACHES_ECP
  },
  {
    component: <PlayersErdp />,
    exact: false,
    href: ROUTES.MATCH_OFFICIALS_ERDP
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.HIGH_POTENTIAL
  },
  {
    component: <PerformancePathway />,
    exact: false,
    href: ROUTES.PERFORMANCE_PATHWAY
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.DUTY_OF_CARE
  },
  {
    component: <GovernanceAndQA />,
    exact: false,
    href: ROUTES.GOVERNANCE_AND_QA
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.INNOVATION_AND_INSIGHTS
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.EQUALITY_DIVERSITY_INCLUSION
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.KPIS
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.PLAYING_TIME
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.ATTENDANCE
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.SUBSTITUTIONS
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.TRANSFERS
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.PLAYER_REGISTRATIONS
  },
  {
    component: <ComingSoon />,
    exact: false,
    href: ROUTES.STAFF_REGISTRATIONS
  }
]
